var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13761_68269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00244141H0V15.9951H24V-0.00244141Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00244141H0V4.49756H24V-0.00244141Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11.4951H0V15.9951H24V11.4951Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.07336C6.75 5.97946 6.68101 5.88936 6.55808 5.82272C6.43514 5.75608 6.26823 5.7183 6.09375 5.71763C5.93166 5.71855 5.70943 5.75105 5.58844 5.80911V5.60837H5.77875V5.44729H5.58844V5.24756H5.28656V5.44729H5.09625V5.60837H5.28656V5.81673C5.19327 5.77149 5.01158 5.74161 4.88768 5.73063C4.76377 5.71966 4.63662 5.72804 4.5213 5.75479C4.40599 5.78154 4.30736 5.82554 4.23711 5.88155C4.16686 5.93757 4.12795 6.00326 4.125 6.07082C4.12687 6.11893 4.14712 6.16631 4.18448 6.21003C4.22184 6.25374 4.27552 6.29285 4.34218 6.32492V6.53327H6.53282V6.32492C6.59891 6.29314 6.65225 6.25444 6.68959 6.21119C6.72694 6.16794 6.74749 6.12104 6.75 6.07336Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.49508C6.75 8.62808 6.75 9.04926 6.09941 9.4372C5.89235 9.56632 5.66945 9.66996 5.4375 9.74754C5.20504 9.67027 4.98283 9.56609 4.77559 9.4372C4.125 9.03264 4.125 8.62808 4.125 8.49508V6.69397H6.75V8.49508Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.125 7.97969V6.69397H5.43748V7.97969H4.125Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43748 9.74754V7.97969H6.75V8.49508C6.75 8.62808 6.75 9.04926 6.09941 9.4372C5.89235 9.56632 5.66943 9.66995 5.43748 9.74754C5.43749 9.74754 5.43748 9.74753 5.43748 9.74754Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6.37256H7.75V9.37256H7.25V6.37256Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25391 6.58679H7.7475L7.875 6.2225H7.125L7.25391 6.58679Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25391 9.22253H7.7475L7.875 9.58682H7.125L7.25391 9.22253Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 6.37256H3.625V9.37256H3.125V6.37256Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 6.58679H3.6225L3.75 6.2225H3L3.12891 6.58679Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 9.22253H3.6225L3.75 9.58682H3L3.12891 9.22253Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13761_68269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/Spain.4f43b1676662e9300dc832aa9c72e8ed.svg";
export { ForwardRef as ReactComponent };